import { setHeight } from "@/lib/dom/setHeight";
import { getHeight } from "@/lib/dom/getHeight";
import { hasClass } from "@/lib/dom/hasClass";
import { addStyle } from "@/lib/dom/addStyle";
import { getSize } from "@/lib/dom/getSize";

const resetHeight = (el: HTMLElement) => {
  const itemSpan = getComputedStyle(document.documentElement).getPropertyValue('--item-span');
  const colLength = parseInt(itemSpan);
  const onsaleEls = Array.from(el.querySelectorAll<HTMLElement>('.onsale_name')).filter(item => {

    // if ($(this).parent().parent().hasClass('slickdeals-banner'))
    //             return;
    if (hasClass(item.parentElement!.parentElement!, 'slickdeals-banner')) {
      return false
    }
    return true;
  })
  const arrItems1 = new Array();
  const arrItems2 = new Array();
  const arrItems4 = new Array();
  const arrItems5 = new Array();
  const arrItems6 = new Array();

  onsaleEls.forEach(item => {
    const parentNode = item.parentNode;
    if (parentNode) {
      let next1 = parentNode.querySelector('.onsale_smallimg')!;
      let next3 = parentNode.querySelector('.onsale_ico')!; //onsale icon
      let next5 = parentNode.querySelector('.onsale_sku')!;
      let next6 = parentNode.querySelector('.onsale_review')!;

      setHeight(item as HTMLElement, '')
      setHeight(next1 as HTMLElement, '')
      setHeight(next3 as HTMLElement, '')
      setHeight(next5 as HTMLElement, '')
      setHeight(next6 as HTMLElement, '')

      arrItems1.push(getHeight(item));
      arrItems2.push(getHeight(next1));
      arrItems4.push(getHeight(next3));
      arrItems5.push(getHeight(next5));
      arrItems6.push(getHeight(next6));
    }
  });


  let MaxHeight1 = 0;
  for (let i = 0; i < arrItems1.length; i++) {
    if (arrItems1[i] > MaxHeight1) {
      MaxHeight1 = arrItems1[i];
    }
    if ((i + 1) % colLength == 0 || (i == arrItems1.length - 1 && (i + 1) % colLength != 0)) {
      let temp1 = 0;
      if ((i + 1) % colLength != 0) {
        temp1 = colLength - (i + 1) % colLength;
      }
      onsaleEls.forEach((el, p) => {
        if (p <= i && p > i - colLength + temp1)
          setHeight(el as HTMLElement, MaxHeight1);
      });
      MaxHeight1 = 0;
    }
  }

  let MaxHeight2 = 0;
  for (let i = 0; i < arrItems2.length; i++) {
    if (arrItems2[i] > MaxHeight2)
      MaxHeight2 = arrItems2[i];
    if ((i + 1) % colLength == 0 || (i == arrItems2.length - 1 && (i + 1) % colLength != 0)) {
      let temp2 = 0;
      if ((i + 1) % colLength != 0)
        temp2 = colLength - (i + 1) % colLength;
      onsaleEls.forEach(function (el, p) {
        if (p <= i && p > i - colLength + temp2)
          setHeight(el.parentNode!.querySelector('.onsale_smallimg')! as HTMLElement, MaxHeight2);
      });
      MaxHeight2 = 0;
    }
  }


  let MaxHeight4 = 0;
  for (let i = 0; i < arrItems4.length; i++) {
    if (arrItems4[i] > MaxHeight4)
      MaxHeight4 = arrItems4[i];
    if ((i + 1) % colLength == 0 || (i == arrItems4.length - 1 && (i + 1) % colLength != 0)) {
      let temp4 = 0;
      if ((i + 1) % colLength != 0)
        temp4 = colLength - (i + 1) % colLength;
      onsaleEls.forEach(function (el, p) {
        if (p <= i && p > i - colLength + temp4)
          // $(this).parent().find('.onsale_ico').height(MaxHeight4);
          setHeight(el.parentNode!.querySelector('.onsale_ico')! as HTMLElement, MaxHeight4);
      });
      MaxHeight4 = 0;
    }
  }

  let MaxHeight5 = 0;
  for (let i = 0; i < arrItems5.length; i++) {
    if (arrItems5[i] > MaxHeight5)
      MaxHeight5 = arrItems5[i];
    if ((i + 1) % colLength == 0 || (i == arrItems5.length - 1 && (i + 1) % colLength != 0)) {
      let temp5 = 0;
      if ((i + 1) % colLength != 0)
        temp5 = colLength - (i + 1) % colLength;
      onsaleEls.forEach(function (el, p) {
        if (p <= i && p > i - colLength + temp5)
          // $(this).parent().find('.onsale_sku').height(MaxHeight5);
          setHeight(el.parentNode!.querySelector('.onsale_sku')! as HTMLElement, MaxHeight5);
      });
      MaxHeight5 = 0;
    }
  }

  let MaxHeight6 = 0;
  for (let i = 0; i < arrItems6.length; i++) {
    if (arrItems6[i] > MaxHeight6)
      MaxHeight6 = arrItems6[i];
    if ((i + 1) % colLength == 0 || (i == arrItems6.length - 1 && (i + 1) % colLength != 0)) {
      let temp6 = 0;
      if ((i + 1) % colLength != 0)
        temp6 = colLength - (i + 1) % colLength;
      onsaleEls.forEach(function (el, p) {
        if (p <= i && p > i - colLength + temp6)
          // $(this).parent().find('.onsale_review').height(MaxHeight6);
          setHeight(el.parentNode!.querySelector('.onsale_review')! as HTMLElement, MaxHeight6);
      });
      MaxHeight6 = 0;
    }
  }


  if (document.querySelector('.slickdeals-banner')) {
    const onsale_main = document.querySelector('#onsale_main')!;

    var onsale = onsale_main.firstElementChild?.querySelector('.onsale-content');
    if (onsale) {
      const slickdeals = document.querySelector<HTMLElement>('.slickdeals')!;
      if (getHeight(slickdeals) > getHeight(onsale)) {
        const onSaleList = document.querySelectorAll<HTMLElement>('.onsale-content');
        for (let index = 0; index < onSaleList.length; index++) {
          const el = onSaleList[index];
          if (hasClass(el, 'slickdeals')) {
            break;
          }
          var diffHeight = Math.ceil(getHeight(slickdeals) - getHeight(el));
          addStyle(el.querySelector<HTMLElement>('.onsale_ico')!, {
            'height': Math.ceil(getHeight(el.querySelector('.onsale_ico')!) - 5 + diffHeight)
          })

          // $(this).find('.onsale_ico').css('height', Math.ceil($(this).find('.onsale_ico').height() - 5 + diffHeight));
        }
      } else {
        addStyle(slickdeals, {
          'height': Math.ceil(getHeight(onsale) + 5)
        })
        // $('.slickdeals').css('height', Math.ceil(onsale.height() + 5));
      }
      // $('.slickdeals-banner').css('min-height', Math.ceil($('#onsale_main').children(':first').height()));
      addStyle('.slickdeals-banner', {
        'min-height': Math.ceil(getHeight(onsale_main.firstChild! as HTMLElement))
      });
    }
  }
  if (document.querySelector('.ad-banner')) {
    const adBanner = document.querySelector<HTMLElement>('.ad-banner')!;
    var onSaleContents = adBanner.parentElement!.previousElementSibling!.querySelector<HTMLElement>('.onsale-content')!;
    const size = getSize(adBanner)
    const adBannerHeight = size.outerHeight;
    if (adBannerHeight > getSize(onSaleContents).outerHeight) {
      var idx = -1;
      const onSaleList = document.querySelectorAll<HTMLElement>('.onsale-content');

      for (let index = 0; index < onSaleList.length; index++) {
        const el = onSaleList[index];
        if (hasClass(el, 'slickdeals')) {
          continue;
        }
        if (index < 4 * colLength) {
          continue;
        }
        if (hasClass(el, 'ad-banner')) {
          break;
        }

        const diffHeight = Math.ceil(adBannerHeight - getSize(el).outerHeight);

        const onsale_ico = el.querySelector<HTMLElement>('.onsale_ico')!

        addStyle(onsale_ico, 'height', Math.ceil(getHeight(onsale_ico) - 5 + diffHeight));


      }
      // document.querySelectorAll('.onsale-content').fo(function () {
      //   idx++;
      //   if ($(this).hasClass('slickdeals')) {
      //     idx++;
      //   }
      //   if (idx < 4 * colLength) {
      //     return;
      //   }
      //   if ($(this).hasClass('ad-banner')) {
      //     return false;
      //   }
      //   const diffHeight = Math.ceil(adBannerHeight - $(this).outerHeight());
      //   $(this).find('.onsale_ico').css('height', Math.ceil($(this).find('.onsale_ico').height() - 5 + diffHeight));
      // });
    }
    // $('.ad-banner').css('min-height', Math.ceil($(onsale).outerHeight()));
    addStyle('.ad-banner', 'min-height', Math.ceil(getSize(onSaleContents).outerHeight));
  }


}

export default resetHeight